var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _mask, _path41, _path42, _path43, _path44, _mask2, _path45, _path46, _mask3, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentAgendaEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.504 41c11.024 0 19.96-8.937 19.96-20S34.529 1 23.505 1C12.48 1 3.544 9.937 3.544 21s8.936 20 19.96 20Z",
    fill: "url(#a)",
    fillOpacity: 0.1,
    stroke: "url(#b)",
    strokeOpacity: 0.15,
    strokeWidth: 0.888,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.748 12.771a1.614 1.614 0 1 0 0-3.228 1.614 1.614 0 0 0 0 3.228Z",
    fill: "url(#c)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.14 11.157a1.392 1.392 0 1 1-2.784 0 1.392 1.392 0 0 1 2.785 0Z",
    stroke: "url(#d)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.11 6.432a1.102 1.102 0 1 0 0-2.204 1.102 1.102 0 0 0 0 2.204Z",
    fill: "url(#e)",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.99 5.33a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0Z",
    stroke: "url(#f)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.165 13.913a1.102 1.102 0 1 0 0-2.205 1.102 1.102 0 0 0 0 2.205Z",
    fill: "url(#g)",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.046 12.81a.88.88 0 1 1-1.761 0 .88.88 0 0 1 1.76 0Z",
    stroke: "url(#h)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.213 37.89a2.047 2.047 0 1 0 0-4.095 2.047 2.047 0 0 0 0 4.094Z",
    fill: "url(#i)",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.038 35.842a1.825 1.825 0 1 1-3.65 0 1.825 1.825 0 0 1 3.65 0Z",
    stroke: "url(#j)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.008 13.007H7.874c-.748 0-1.338-.59-1.338-1.339V3.991c0-.748.59-1.339 1.338-1.339H41.97c.748 0 1.338.59 1.338 1.339v7.677c.04.748-.59 1.339-1.299 1.339Z",
    fill: "#fff",
    stroke: "url(#k)",
    strokeOpacity: 0.15,
    strokeWidth: 0.888,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.803 7.81c0 .866-.393 1.654-.984 2.205a2.91 2.91 0 0 1-1.968.748 2.91 2.91 0 0 1-1.969-.748 2.893 2.893 0 0 1-.984-2.205 2.974 2.974 0 0 1 2.953-2.953 2.974 2.974 0 0 1 2.952 2.953Z",
    fill: "url(#l)",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m10.033 9.852-.005-.004A2.672 2.672 0 0 1 9.12 7.81c0-1.491 1.24-2.73 2.73-2.73 1.492 0 2.732 1.239 2.732 2.73 0 .798-.363 1.528-.914 2.042a2.689 2.689 0 0 1-1.817.689 2.689 2.689 0 0 1-1.818-.69Z",
    stroke: "url(#m)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.819 10.015a2.91 2.91 0 0 1-1.969.748 2.91 2.91 0 0 1-1.968-.748c.236-.078.512-.196.866-.354a.474.474 0 0 0 .197-.197c.04-.04.04-.118.04-.157v-.748l-.04-.04a.447.447 0 0 1-.118-.315l-.079-.039c-.197.04-.157-.157-.236-.551 0-.158 0-.197.079-.236l.078-.08c-.354-.826-.197-1.338.197-1.534-.118-.276-.118-.355-.118-.355s.787.118 1.024.079c.354-.079.866 0 1.063.472.315.118.433.315.472.552.04.354-.157.748-.197.866.04.039.079.078.04.197-.04.354-.04.59-.237.55l-.157.355v.866c0 .079.04.158.04.197.039.079.117.118.157.158.354.118.63.236.866.314Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.37 10.087c-.43.29-.962.455-1.52.455-.559 0-1.092-.166-1.523-.457a19.5 19.5 0 0 0 .511-.221l.01-.004a.7.7 0 0 0 .282-.27.38.38 0 0 0 .068-.168c.008-.048.008-.093.008-.113v-.842l-.065-.065-.04-.04a.228.228 0 0 1-.052-.158v-.137l-.123-.061-.079-.04-.059-.029a4.67 4.67 0 0 1-.014-.097V7.84c-.01-.068-.022-.151-.04-.247v-.044l.013-.013.08-.08.105-.105-.059-.138c-.167-.391-.201-.68-.167-.88a.477.477 0 0 1 .26-.37l.187-.094-.083-.192.077.008c.115.012.24.024.354.03.107.005.222.007.307-.007l.012-.002c.307-.069.673.014.81.34l.037.09.09.033c.127.048.199.105.243.161a.46.46 0 0 1 .087.213c.013.13-.016.28-.06.425a2.783 2.783 0 0 1-.087.234 2.214 2.214 0 0 0-.04.107l-.044.13.079.078-.003.01-.003.024a9.645 9.645 0 0 0-.026.24c-.005.043-.01.077-.016.104l-.104-.02-.072.162-.158.354-.02.043V9.346a.637.637 0 0 0 .036.197l.004.016v.036l.024.047c.04.08.095.132.135.165l.043.034a.261.261 0 0 1 .006.005l.015.012.037.036.05.017c.172.058.326.115.468.17l.02.006Zm-2.564-2.075Z",
    stroke: "url(#n)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 7.417a.76.76 0 0 0-.082-.287v-.04c-.164-.329-.492-.452-.82-.452-.819-.04-.9.123-1.188-.122.082.122.082.327-.04.573-.083.164-.247.246-.41.287-.37-.86-.205-1.393.204-1.598-.123-.287-.123-.369-.123-.369s.82.123 1.066.082c.369-.082.901 0 1.106.492.328.123.451.328.492.574.04.286-.164.696-.205.86Z",
    fill: "#80859D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.106 6.59a.59.59 0 0 1-.013.185c-.23-.262-.564-.357-.869-.358a5.536 5.536 0 0 0-.689.008l-.117.007a.366.366 0 0 1-.127-.01.35.35 0 0 1-.116-.075l-.33.292c.019.027.052.138-.054.351a.256.256 0 0 1-.086.096c-.107-.307-.126-.544-.096-.717a.505.505 0 0 1 .275-.393l.187-.093-.083-.192-.006-.016.096.011c.12.013.25.025.367.031.112.006.23.008.318-.007l.012-.002c.322-.072.71.014.853.36l.037.089.09.034c.134.05.21.11.257.17a.49.49 0 0 1 .094.23Z",
    stroke: "url(#o)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.795 9.544v.158h-1.85v-.197c.04-.04.04-.118.04-.158V8.6l-.04-.04v-.038c.04.078.079.118.157.196l.59.394c.119.118.316.118.473 0l.552-.472.039-.04v.788c-.04.039 0 .078.04.157Z",
    fill: "url(#p)",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.524 9.48h-1.329a.483.483 0 0 0 .003-.017c.008-.048.008-.093.008-.113v-.297l.348.232c.215.196.528.166.745.004l.005-.005.006-.004.224-.193V9.33a.266.266 0 0 0-.01.15Z",
    stroke: "url(#q)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.488 6.945H16.93a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h7.56a.31.31 0 0 1 .314.315v.984c0 .197-.118.315-.315.315Z",
    fill: "url(#r)",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.488 6.723H16.93c-.035 0-.055-.012-.067-.026a.1.1 0 0 1-.026-.067v-.984c0-.035.013-.055.027-.068a.1.1 0 0 1 .066-.025h7.56c.034 0 .054.012.067.026a.101.101 0 0 1 .025.067v.984c0 .054-.015.071-.018.075-.004.003-.02.018-.075.018Z",
    stroke: "url(#s)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.465 10.292H16.929a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h16.536a.31.31 0 0 1 .315.315v.984a.31.31 0 0 1-.315.315Z",
    fill: "#CEF5F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.465 10.07H16.929c-.035 0-.055-.012-.067-.027a.1.1 0 0 1-.026-.066v-.984c0-.035.013-.055.027-.068a.1.1 0 0 1 .066-.025h16.536c.035 0 .054.012.067.026a.101.101 0 0 1 .026.067v.984c0 .035-.013.055-.027.068a.1.1 0 0 1-.066.025Z",
    stroke: "url(#t)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.008 38.834H7.874c-.748 0-1.338-.59-1.338-1.339v-7.677c0-.748.59-1.338 1.338-1.338H41.97c.748 0 1.338.59 1.338 1.338v7.677c.04.748-.59 1.339-1.299 1.339Z",
    fill: "#fff",
    stroke: "url(#u)",
    strokeOpacity: 0.15,
    strokeWidth: 0.888,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.803 33.637c0 .867-.393 1.654-.984 2.205a2.91 2.91 0 0 1-1.968.748 2.91 2.91 0 0 1-1.969-.748 2.894 2.894 0 0 1-.984-2.205 2.974 2.974 0 0 1 2.953-2.952 2.974 2.974 0 0 1 2.952 2.952Z",
    fill: "url(#v)",
    fillOpacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m10.033 35.679-.005-.004a2.672 2.672 0 0 1-.908-2.038c0-1.491 1.24-2.73 2.73-2.73 1.492 0 2.732 1.239 2.732 2.73 0 .798-.363 1.528-.914 2.042a2.688 2.688 0 0 1-1.817.69 2.689 2.689 0 0 1-1.818-.69Z",
    stroke: "url(#w)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.819 35.842a2.91 2.91 0 0 1-1.969.748 2.91 2.91 0 0 1-1.968-.748c.236-.08.512-.197.866-.355a.474.474 0 0 0 .197-.197c.04-.039.04-.118.04-.157v-.748l-.04-.04a.447.447 0 0 1-.118-.314l-.079-.04c-.197.04-.157-.157-.236-.55 0-.158 0-.198.079-.237l.078-.079c-.354-.827-.197-1.338.197-1.535-.118-.276-.118-.355-.118-.355s.787.119 1.024.08c.354-.08.866 0 1.063.471.315.119.433.316.472.552.04.354-.157.748-.197.866.04.04.079.079.04.197-.04.354-.04.59-.237.55l-.157.316v.866c0 .079.04.157.04.197.039.079.117.118.157.157.354.197.63.276.866.355Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 35.92a2.736 2.736 0 0 1-1.51.448c-.559 0-1.092-.166-1.523-.457.154-.063.323-.137.511-.22l.01-.005a.7.7 0 0 0 .282-.27.38.38 0 0 0 .068-.168c.008-.048.008-.093.008-.113v-.842l-.065-.065-.04-.04a.228.228 0 0 1-.052-.157v-.137l-.123-.062-.079-.04-.059-.029a4.69 4.69 0 0 1-.014-.097c-.01-.069-.022-.152-.04-.247v-.045l.013-.013.08-.079.105-.106-.059-.138c-.167-.391-.201-.68-.167-.879a.477.477 0 0 1 .26-.37l.187-.094-.083-.193.077.008c.115.013.24.024.354.03.107.006.222.007.307-.007l.012-.002c.307-.069.673.014.81.34l.037.09.09.033c.127.048.199.105.243.161a.46.46 0 0 1 .087.213c.013.13-.016.281-.06.425a2.783 2.783 0 0 1-.087.235 2.205 2.205 0 0 0-.04.106l-.044.13.079.078-.003.01-.003.024a9.688 9.688 0 0 0-.026.24c-.005.043-.01.078-.016.104l-.096-.019-.076.152-.158.315-.023.047V35.133a.636.636 0 0 0 .035.197l.004.016v.036l.024.047c.04.08.095.132.135.165l.043.034.006.005.015.012.022.021.027.015c.192.107.363.181.516.239Zm-2.554-2.082Z",
    stroke: "url(#x)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 33.243a.759.759 0 0 0-.081-.287v-.04c-.164-.328-.492-.451-.82-.451-.82-.041-.901.123-1.188-.123.082.123.082.328-.041.573-.082.164-.246.246-.41.287-.369-.86-.205-1.393.205-1.598-.123-.287-.123-.369-.123-.369s.82.123 1.065.082c.37-.082.902 0 1.107.492.328.123.45.328.491.574.041.328-.163.696-.204.86Z",
    fill: "#80859D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.106 32.414a.656.656 0 0 1-.01.19c-.23-.264-.565-.36-.871-.361a5.548 5.548 0 0 0-.69.008 3.463 3.463 0 0 1-.117.007.364.364 0 0 1-.127-.01.35.35 0 0 1-.116-.075l-.329.292c.018.027.052.138-.055.351a.258.258 0 0 1-.086.096c-.106-.307-.126-.544-.096-.717a.505.505 0 0 1 .275-.392l.187-.094-.082-.192a1 1 0 0 1-.007-.016 8.225 8.225 0 0 0 .464.042c.111.006.23.008.318-.007l.011-.002c.322-.072.71.014.854.36l.037.09.09.033c.133.05.21.11.257.17.047.06.076.133.093.227Z",
    stroke: "url(#y)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.795 35.37v.158h-1.85v-.197c.04-.04.04-.118.04-.158v-.748l-.04-.039v-.04c.04.08.079.119.157.198l.59.393c.119.118.316.118.473 0l.552-.472.039-.04v.788c-.04.04 0 .118.04.157Z",
    fill: "url(#z)",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.522 35.306h-1.327a.53.53 0 0 0 .003-.017c.008-.048.008-.093.008-.113v-.297l.348.232c.215.197.528.166.745.004l.005-.005.006-.004.224-.192V35.158a.303.303 0 0 0-.012.149Z",
    stroke: "url(#A)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.488 32.81H16.93a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h7.56a.31.31 0 0 1 .314.315v.985a.31.31 0 0 1-.315.314Z",
    fill: "url(#B)",
    fillOpacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.488 32.589H16.93c-.035 0-.055-.013-.067-.027a.1.1 0 0 1-.026-.066v-.985c0-.035.013-.055.027-.067a.101.101 0 0 1 .066-.026h7.56c.034 0 .054.013.067.027a.101.101 0 0 1 .025.066v.985c0 .024-.01.05-.025.066-.013.014-.033.027-.068.027Z",
    stroke: "url(#C)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.465 36.157H16.929a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h16.536a.31.31 0 0 1 .315.315v.984a.339.339 0 0 1-.315.315Z",
    fill: "#FFF8EB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.465 35.935H16.929c-.035 0-.055-.012-.067-.026a.1.1 0 0 1-.026-.067v-.984c0-.035.013-.055.027-.068a.101.101 0 0 1 .066-.025h16.536c.035 0 .054.012.067.026a.1.1 0 0 1 .026.067v.984c0 .007-.006.032-.034.06-.028.028-.053.033-.06.033Z",
    stroke: "url(#D)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.22 25.92H2.127c-.748 0-1.338-.59-1.338-1.338v-7.677c0-.748.59-1.339 1.338-1.339h34.095c.748 0 1.338.591 1.338 1.339v7.677c.04.748-.59 1.339-1.338 1.339Z",
    fill: "#fff",
    stroke: "url(#E)",
    strokeOpacity: 0.15,
    strokeWidth: 0.888,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74 19.858h-7.559a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h7.56a.31.31 0 0 1 .314.315v.984c0 .197-.118.315-.315.315Z",
    fill: "url(#F)",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M18.74 19.636h-7.559c-.035 0-.055-.012-.067-.026a.1.1 0 0 1-.026-.067v-.984c0-.035.013-.055.027-.068a.1.1 0 0 1 .066-.025h7.56c.034 0 .054.012.067.026a.1.1 0 0 1 .025.067v.984c0 .054-.015.071-.018.075-.004.003-.02.018-.075.018Z",
    stroke: "url(#G)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.717 23.244H11.18a.31.31 0 0 1-.315-.315v-.984a.31.31 0 0 1 .315-.315h16.496a.31.31 0 0 1 .315.315v.984c.04.158-.118.315-.275.315Z",
    fill: "#D7F2FE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77 22.93v.026l.006.023a.053.053 0 0 1-.011.017.095.095 0 0 1-.029.02.05.05 0 0 1-.02.006H11.182c-.035 0-.055-.012-.067-.026a.1.1 0 0 1-.026-.067v-.984c0-.035.013-.055.027-.068a.101.101 0 0 1 .066-.025h16.496c.035 0 .055.012.068.026a.1.1 0 0 1 .025.067v.984Zm.006.047v.001-.001Z",
    stroke: "url(#H)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.095 20.723c0 .827-.355 1.575-.906 2.126l-.078.079a2.91 2.91 0 0 1-1.969.748 2.975 2.975 0 0 1-1.93-.709h-.038a2.95 2.95 0 0 1-1.024-2.244 2.974 2.974 0 0 1 2.953-2.953c1.653 0 2.992 1.34 2.992 2.953Z",
    fill: "url(#I)",
    fillOpacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m4.356 22.798-.143.17v-.046l.107-.122a2.728 2.728 0 0 1-.948-2.077c0-1.491 1.239-2.73 2.73-2.73 1.534 0 2.77 1.24 2.77 2.73 0 .762-.325 1.455-.84 1.97l-.039.039-.036.036a2.69 2.69 0 0 1-1.815.686 2.753 2.753 0 0 1-1.786-.656Z",
    stroke: "url(#J)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.178 22.908c-.12-.28-.32-.52-.639-.68a.948.948 0 0 0-.479-.119h-.12c-.28 0-.32-.04-.32-.04v-.479c.32-.24.56-.559.64-.918.2-.04.32-.2.28-.4 0-.08-.08-.16-.08-.239v-.28c0-.16-.04-.279-.16-.439a1.41 1.41 0 0 0-1.238-.718c-.12 0-.2 0-.32.04-.2.04-.359.12-.519.24l-.08.079-.04.04c-.159.16-.279.36-.359.559-.08.2-.08.44-.08.679v.12s0 .04-.04.04c.08-.08.04.04.08.12.08.199.2.159.36.279h-.04l-.16.04c-.878.279-.958 1.197-.08 1.397-.08.04-.12.08-.16.08-.239.2-.399.439-.478.678.519.44 1.197.72 1.956.72.758 0 1.477-.28 1.996-.76.04.04.08 0 .08-.04.04 0 .04 0 0 0Zm-2.475-.959-.08-.08c-.04-.04-.08-.04-.12-.08 0 0-.04 0-.04-.04-.12-.08-.24-.159-.28-.279 0-.04.04-.12.12-.2.04.04.08.08.12.16l.12.12c.04 0 .08.04.08.08h.08v.32Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.178 22.908c-.12-.28-.32-.52-.639-.68a.948.948 0 0 0-.479-.119h-.12c-.28 0-.32-.04-.32-.04v-.479c.32-.24.56-.559.64-.918.2-.04.32-.2.28-.4 0-.08-.08-.16-.08-.239v-.28c0-.16-.04-.279-.16-.439a1.41 1.41 0 0 0-1.238-.718c-.12 0-.2 0-.32.04-.2.04-.359.12-.519.24l-.08.079-.04.04c-.159.16-.279.36-.359.559-.08.2-.08.44-.08.679v.12s0 .04-.04.04c.08-.08.04.04.08.12.08.199.2.159.36.279h-.04l-.16.04c-.878.279-.958 1.197-.08 1.397-.08.04-.12.08-.16.08-.239.2-.399.439-.478.678.519.44 1.197.72 1.956.72.758 0 1.477-.28 1.996-.76.04.04.08 0 .08-.04.04 0 .04 0 0 0Zm-2.475-.959-.08-.08c-.04-.04-.08-.04-.12-.08 0 0-.04 0-.04-.04-.12-.08-.24-.159-.28-.279 0-.04.04-.12.12-.2.04.04.08.08.12.16l.12.12c.04 0 .08.04.08.08h.08v.32Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62 22.07h-.443v.183l.13.13.314-.314Zm0-.48-.265-.355-.178.133v.222h.444Zm.64-.918-.087-.435-.284.056-.063.283.434.096Zm.28-.4h-.445v.045l.009.043.435-.087Zm-.24-.958-.39.213.015.028.02.026.355-.267Zm-1.557-.678.087.435.027-.006.026-.008-.14-.421Zm-.52.24-.266-.356-.025.019-.022.022.313.314Zm-.08.079-.313-.314-.1.1-.024.141.438.073Zm-.478 1.397H4.22h.444Zm-.04.04-.314-.314-.758.758h1.072v-.444Zm.08.12.412-.165-.007-.017-.009-.016-.397.198Zm.359.28-.267.355.119.088h.148v-.443Zm-.04 0v-.444h-.055l-.053.013.108.43Zm-.16.04-.107-.431-.014.003-.013.005.134.422Zm-.08 1.397.199.397 1.11-.555-1.21-.275-.099.433Zm-.16.08v-.444h-.16l-.124.103.285.34Zm-.478.678-.422-.14-.095.285.23.194.287-.338Zm3.952-.04.314-.313-.302-.302-.313.29.301.326ZM5.623 21.87l-.314.313.314-.313Zm-.12-.08.314-.314-.13-.13h-.184v.444Zm-.04-.04h.444v-.238l-.198-.131-.246.369Zm-.28-.28H4.74v.072l.022.069.422-.14Zm.12-.2.314-.313-.314-.314-.314.314.314.314Zm.12.16-.397.199.032.064.051.051.314-.314Zm.12.12-.314.314.13.13h.184v-.444Zm.08.08v.444h.444v-.444h-.444Zm.08 0h.443v-.444h-.443v.444Zm2.883 1.103a1.757 1.757 0 0 0-.848-.901l-.397.794a.87.87 0 0 1 .429.456l.816-.35Zm-.848-.901a1.386 1.386 0 0 0-.678-.167v.888c.114 0 .166.016.28.073l.398-.794Zm-.678-.167h-.12v.888h.12v-.888Zm-.12 0c-.06 0-.101-.002-.13-.004l-.038-.005s.018.004.045.016a.377.377 0 0 1 .1.067l.01.008.003.004.003.002v.001c.001 0 .002.001-.312.315s-.313.315-.313.315l.001.001.002.002.005.004.008.009a.433.433 0 0 0 .121.078c.044.02.09.034.134.044.089.02.204.031.361.031v-.888Zm.125.404v-.479h-.888v.48h.888Zm-.178-.124c.38-.285.697-.689.806-1.177l-.867-.192c-.05.23-.213.465-.471.659l.532.71Zm.46-.838a.77.77 0 0 0 .628-.921l-.871.174a.09.09 0 0 1 .001-.034.138.138 0 0 1 .023-.052c.024-.034.05-.038.045-.037l.174.87Zm.636-.834a.614.614 0 0 0-.04-.216c-.018-.046-.039-.087-.047-.103-.012-.024-.01-.023-.009-.017a.279.279 0 0 1 .016.096h-.888c0 .093.023.168.041.216.017.045.038.087.046.102.012.024.011.023.01.018a.277.277 0 0 1-.017-.096h.888Zm-.08-.24V19.913h-.888V20.034h.888Zm0-.12V19.833h-.888V19.914h.888Zm0-.08V19.753h-.888V19.834h.888Zm0-.08c0-.268-.08-.48-.248-.705l-.71.533a.41.41 0 0 1 .061.102c.005.013.01.03.01.07h.887Zm-.214-.651a1.854 1.854 0 0 0-1.627-.95v.888c.363 0 .69.196.848.487l.78-.425Zm-1.627-.95c-.124 0-.267-.002-.46.063l.28.842a.267.267 0 0 1 .064-.015c.024-.002.051-.002.116-.002v-.888Zm-.407.048a1.68 1.68 0 0 0-.698.32l.533.71a.795.795 0 0 1 .34-.16l-.175-.87Zm-.745.361-.04.04-.04.04.627.628.04-.04.04-.04-.627-.628Zm.234.394c-.438-.073-.396-.201-.317-.31l.001-.002.001-.001-.004.004-.035.035.628.628.035-.035.004-.005h.001l.001-.002.001-.001c.08-.11.122-.238-.316-.311Zm-.354-.274c-.21.21-.36.464-.458.708l.825.33c.062-.156.151-.301.26-.41l-.627-.628Zm-.458.708c-.117.294-.111.627-.111.844h.887c0-.262.007-.41.049-.514l-.825-.33Zm.333.844H4.22V20.273h.887V20.232h-.443Zm-.444.04V20.353h.887V20.272h-.887Zm.444.08-.444-.001v-.003a.408.408 0 0 1 .042-.175.408.408 0 0 1 .362-.226v.888a.484.484 0 0 0 .483-.476v-.007h-.443Zm.273.353a.341.341 0 0 1-.051.04.431.431 0 0 1-.61-.173c-.028-.058-.035-.106-.035-.108-.002-.008-.002-.013 0 0l.005.048c.006.039.02.116.06.198l.794-.397a.278.278 0 0 1 .024.07V20.37c-.002-.006-.004-.029-.008-.052-.002-.016-.012-.077-.046-.143a.456.456 0 0 0-.66-.18.59.59 0 0 0-.1.082l.627.628Zm-.646-.029a.727.727 0 0 0 .432.433l.04.018a.167.167 0 0 1 .033.019l.533-.71a1.044 1.044 0 0 0-.192-.114l-.06-.027a.538.538 0 0 1-.025-.011c-.002-.001.018.009.04.032.022.023.027.039.024.03l-.825.33Zm.772.115v-.444H5.023v.887H5.064v-.443Zm-.148-.431-.16.04.216.861.16-.04-.216-.861Zm-.186.047c-.56.179-.971.6-1.007 1.122-.04.561.368.996.963 1.132l.197-.866c-.148-.033-.216-.088-.244-.12a.11.11 0 0 1-.03-.085c.003-.058.07-.235.39-.337l-.27-.846Zm-.144 1.424a1.212 1.212 0 0 0-.11.062l-.015.01c-.003 0-.002 0 .001-.002a.367.367 0 0 1 .162-.038v.889a.524.524 0 0 0 .294-.089c.044-.026.045-.028.065-.038l-.397-.794Zm-.246.136a1.966 1.966 0 0 0-.616.88l.843.28c.052-.156.161-.328.342-.478l-.569-.682Zm-.481 1.358a3.46 3.46 0 0 0 2.243.824v-.888a2.573 2.573 0 0 1-1.67-.613l-.573.677Zm2.243.824c.865 0 1.693-.318 2.297-.876l-.602-.653c-.434.4-1.043.641-1.695.641v.888Zm1.682-.889a.48.48 0 0 0 .615.065.505.505 0 0 0 .223-.418h-.888c0-.11.05-.237.173-.32a.407.407 0 0 1 .505.046l-.628.627Zm.394.09H8.208v-.887H8.177v.888H8.208v-.888H8.177v.888Zm-2.162-1.715-.054-.055-.019-.018-.005-.005v-.002h-.001l-.314.314-.314.313.002.002.005.005.018.018.055.055.627-.627Zm-.08-.08c-.075-.076-.155-.113-.175-.123-.02-.01.02.007.056.043l-.628.628c.076.076.155.113.175.123.02.01-.02-.008-.055-.044l.628-.627Zm-.433.234v-.444h.03a.403.403 0 0 1 .374.404h-.888a.484.484 0 0 0 .469.483H5.502l.001-.443Zm.206-.41-.076-.051a.504.504 0 0 1-.043-.034c-.018-.017.001-.005.015.035l-.843.28c.054.16.153.272.234.345.079.07.167.128.22.164l.493-.738Zm-.082.09a.36.36 0 0 1-.017.11c-.005.016-.01.024-.011.026-.002.002.003-.007.018-.022l-.628-.627a1 1 0 0 0-.16.208.624.624 0 0 0-.09.305h.888Zm-.638.114a.404.404 0 0 1 .028.029l.01.016.793-.397c-.073-.145-.154-.226-.203-.275l-.628.627Zm.12.16.06.06.06.06.628-.628-.06-.06-.06-.06-.628.628Zm.434.25a.364.364 0 0 1-.26-.105.365.365 0 0 1-.104-.259h.888a.523.523 0 0 0-.155-.369.523.523 0 0 0-.37-.155v.888Zm.08-.364v.444H5.663v-.888H5.622v.444Zm.04 0v.444H5.703v-.888H5.662v.444Zm-.404 0v.32h.887v-.32H5.26Z",
    fill: "url(#K)",
    fillOpacity: 0.15,
    mask: "url(#L)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6.989 22.086c-.04.158-.118.276-.118.276l-1.496-.237.078-.393s.04 0 .04.04c.039.038.078.038.118.078.04 0 .04.04.078.078v-.275H5.65c.236.118.551.197.984-.079v.473c.04 0 .08.039.355.039Z",
    fill: "url(#M)",
    fillOpacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.412 22.047v.018l-.5-.08v-.014a1.026 1.026 0 0 0 .5-.045v.12Zm-.5-.301a.86.86 0 0 0 .5-.056l-.5.056Z",
    stroke: "url(#N)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.677 19.893c.281 0 .562-.04.803-.12 0 0 0-.04.04-.08-.04-.12-.08-.281-.16-.442a1.417 1.417 0 0 0-1.244-.722c-.12 0-.236.009-.397.049a1.498 1.498 0 0 0-.365.154s-.117.079-.201.158c-.085.08-.281.361-.362.562-.08.24-.145.445-.104.686.04 0 .104-.044.145-.044.32-.16.561-.361.682-.682.32.28.722.441 1.163.482Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.677 19.893c.281 0 .562-.04.803-.12 0 0 0-.04.04-.08-.04-.12-.08-.281-.16-.442a1.417 1.417 0 0 0-1.244-.722c-.12 0-.236.009-.397.049a1.498 1.498 0 0 0-.365.154s-.117.079-.201.158c-.085.08-.281.361-.362.562-.08.24-.145.445-.104.686.04 0 .104-.044.145-.044.32-.16.561-.361.682-.682.32.28.722.441 1.163.482Z",
    fill: "#80859D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m7.48 19.773.14.421.304-.1v-.32H7.48Zm-.803.12-.04.443.02.001h.02v-.444Zm-1.163-.481.292-.334-.483-.422-.225.6.416.156Zm-.682.682v.444h.104l.094-.047-.198-.397Zm-.145.044-.438.073.062.371h.376v-.444Zm.104-.686-.412-.165-.005.012-.004.013.421.14Zm.362-.562-.305-.322.305.322Zm.201-.158-.23-.38-.009.006-.008.005.247.369Zm.365-.154-.108-.43-.01.002-.012.004.13.424Zm1.64.674.397-.199-.003-.007-.004-.007-.39.212Zm.16.44.315.315.194-.194-.087-.26-.421.14Zm-.18-.34c-.188.063-.42.098-.662.098v.887c.32 0 .65-.045.943-.143l-.28-.842Zm-.622.1a1.576 1.576 0 0 1-.911-.374l-.585.668c.399.349.891.542 1.416.59l.08-.884Zm-1.619-.196c-.066.176-.198.308-.465.441l.397.794c.375-.187.724-.457.9-.923l-.832-.312Zm-.266.394a.524.524 0 0 0-.175.03c-.032.01-.06.023-.07.027l-.008.003a.367.367 0 0 1 .107-.016v.888a.524.524 0 0 0 .176-.03c.03-.01.06-.023.07-.027l.007-.003a.367.367 0 0 1-.107.016v-.888Zm.292.415c-.02-.118.005-.223.089-.473l-.843-.28c-.077.232-.182.536-.121.9l.875-.147Zm.08-.448a1.95 1.95 0 0 1 .22-.362l.033-.042-.61-.645a1.952 1.952 0 0 0-.247.313 2.399 2.399 0 0 0-.22.406l.824.33Zm.38-.506a.656.656 0 0 1 .075-.04c.039-.017.099-.04.19-.069l-.26-.848a1.94 1.94 0 0 0-.465.198l.46.76Zm.242-.102c.12-.03.199-.036.29-.036v-.888c-.15 0-.303.012-.505.062l.215.862Zm.29-.036c.365 0 .694.198.854.491l.779-.425a1.86 1.86 0 0 0-1.633-.954v.888Zm.846.477c.062.123.083.223.137.383l.842-.28c-.027-.08-.086-.302-.185-.5l-.794.397Zm.244-.071a.586.586 0 0 0-.17.387v.006l.444.001h.444v.004a.408.408 0 0 1-.018.111.303.303 0 0 1-.072.119l-.628-.628Zm-1.852-.647-.248-.369v.001l-.002.002a1.985 1.985 0 0 0-.256.202l.61.645a1.112 1.112 0 0 1 .142-.112l.002-.001-.248-.368Z",
    fill: "url(#O)",
    fillOpacity: 0.15,
    mask: "url(#P)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.315 21.314.119.118-.119-.118Z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m5.315 21.314.119.118-.119-.118Z",
    fill: "#3973F4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m5.002 21.627.059.06.059.059.628-.628-.06-.06L5.63 21l-.627.627Zm.746-.509-.06-.06L5.63 21l-.627.627.059.06.059.059.628-.628Z",
    fill: "url(#Q)",
    fillOpacity: 0.15,
    mask: "url(#R)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M5.866 22.77c-.118.157-.315.157-.511.157.196-.197.078-.788-.552-.709-.905-.157-.787-1.102.079-1.378l.158-.04.039.04c.079.197.157.315.276.473-.355.315.157.393.393.63.158.078.315.59.118.826Z",
    fill: "#80859D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m5.696 22.627-.007.01a.117.117 0 0 1-.026.025.707.707 0 0 0-.077-.294c-.127-.247-.396-.41-.774-.374a.594.594 0 0 1-.335-.167.304.304 0 0 1-.078-.235c.015-.175.174-.415.533-.535.044.091.09.168.14.244a.385.385 0 0 0-.06.217c.005.16.114.261.181.314.058.045.132.089.192.124l.038.023c.075.045.13.082.168.12l.026.026.021.01a.228.228 0 0 1 .027.042c.023.042.044.1.058.165.03.144.006.245-.027.285Z",
    stroke: "url(#S)",
    strokeOpacity: 0.15,
    strokeWidth: 0.444
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 64.645,
    y1: 21,
    x2: 13.829,
    y2: 22.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 64.645,
    y1: 21,
    x2: 13.829,
    y2: 22.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 49.075,
    y1: 11.157,
    x2: 44.966,
    y2: 11.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 49.075,
    y1: 11.157,
    x2: 44.966,
    y2: 11.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 50.382,
    y1: 5.33,
    x2: 47.576,
    y2: 5.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 50.382,
    y1: 5.33,
    x2: 47.576,
    y2: 5.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 4.437,
    y1: 12.81,
    x2: 1.631,
    y2: 12.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 4.437,
    y1: 12.81,
    x2: 1.631,
    y2: 12.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 8.432,
    y1: 35.842,
    x2: 3.22,
    y2: 35.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 8.432,
    y1: 35.842,
    x2: 3.22,
    y2: 35.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 62.819,
    y1: 7.83,
    x2: 16.322,
    y2: 11.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 17.937,
    y1: 7.81,
    x2: 10.419,
    y2: 7.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 17.937,
    y1: 7.81,
    x2: 10.419,
    y2: 7.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 15.908,
    y1: 8.086,
    x2: 10.895,
    y2: 8.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 14.899,
    y1: 6.413,
    x2: 11.138,
    y2: 6.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 13.777,
    y1: 9.111,
    x2: 11.424,
    y2: 9.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 13.777,
    y1: 9.111,
    x2: 11.424,
    y2: 9.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 29.148,
    y1: 6.138,
    x2: 18.871,
    y2: 7.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 29.148,
    y1: 6.138,
    x2: 18.871,
    y2: 7.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 42.887,
    y1: 9.485,
    x2: 22.365,
    y2: 14.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 62.819,
    y1: 33.657,
    x2: 16.322,
    y2: 37.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 17.937,
    y1: 33.637,
    x2: 10.419,
    y2: 33.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 17.937,
    y1: 33.637,
    x2: 10.419,
    y2: 33.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 15.908,
    y1: 33.913,
    x2: 10.895,
    y2: 34.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 14.899,
    y1: 32.239,
    x2: 11.139,
    y2: 32.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 13.777,
    y1: 34.937,
    x2: 11.424,
    y2: 35.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 13.777,
    y1: 34.937,
    x2: 11.424,
    y2: 35.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 29.148,
    y1: 32.003,
    x2: 18.871,
    y2: 33.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 29.148,
    y1: 32.003,
    x2: 18.871,
    y2: 33.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 42.887,
    y1: 35.35,
    x2: 22.365,
    y2: 40.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 57.071,
    y1: 20.744,
    x2: 10.574,
    y2: 24.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 23.4,
    y1: 19.051,
    x2: 13.123,
    y2: 20.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 23.4,
    y1: 19.051,
    x2: 13.123,
    y2: 20.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 37.088,
    y1: 22.437,
    x2: 16.601,
    y2: 27.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 12.249,
    y1: 20.723,
    x2: 4.682,
    y2: 20.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 12.249,
    y1: 20.723,
    x2: 4.682,
    y2: 20.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 10.363,
    y1: 21.151,
    x2: 5.191,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 7.845,
    y1: 21.968,
    x2: 5.794,
    y2: 22.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 7.845,
    y1: 21.968,
    x2: 5.794,
    y2: 22.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 9.03,
    y1: 19.334,
    x2: 5.412,
    y2: 19.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 5.497,
    y1: 21.373,
    x2: 5.346,
    y2: 21.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 6.904,
    y1: 21.864,
    x2: 4.635,
    y2: 21.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8912CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E00EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentAgendaEmpty);
export default __webpack_public_path__ + "static/media/current-agenda-empty.e86f468327caef41c9badabc2fa629700a3271047005667fb145c90c2daa8d29.svg";
export { ForwardRef as ReactComponent };